export const toolTipText = {
  methods: {
    toolTipText(text) {
      return text.substring(0, 200) + "...";
    }
  }
};
